import { getFeatureSwitchStatic } from '../utils/general';
export var PRINT_LABEL_MINIMUM_VERSION = {
    iOS: getFeatureSwitchStatic('iOSPrintLabelVersion', false) ||
        '7.34.0',
    Android: getFeatureSwitchStatic('AndroidPrintLabelVersion', false) ||
        '7.34.0',
};
